
/**
 * Objeto para armazenar as mensagens de erro da opção de resposta  
 */
class ErroQuestionarioOpcao {

    /**
     * Cria uma nova instância da lista de erros da opção de resposta
     * Caso os parâmetros não sejam informados, cria com valores padrão
     * 
     * @member {Boolean} valido Indica se o objeto é valido ou não
     * @member {String} erroOpcao Mensagem de erro geral do objeto
     * @member {String} descricao Mensagem de erro para a descrição
     * @member {String} imagem Mensagem de erro para a imagem
     * @member {String} valor Mensagem de erro para o valor
     */
    constructor(valido, erroOpcao, descricao, imagem, valor) {
        /** @member {Boolean} valido Indica se o objeto é valido ou não */
        this.valido = valido ?? true;
        /** @member {String} erroOpcao Mensagem de erro geral do objeto */
        this.erroOpcao = erroOpcao ?? '';
        /** @member {String} descricao Mensagem de erro para a descrição */
        this.descricao = descricao ?? '';
        /** @member {String} imagem Mensagem de erro para a imagem */
        this.imagem = imagem ?? '';
        /** @member {String} valor Mensagem de erro para o valor */
        this.valor = valor ?? '';
    }

    /**
     * Verifica se dois objetos possuem os mesmos valores
     * @param {ErroQuestionarioOpcao} obj1 Primeiro objeto a ser comparado
     * @param {ErroQuestionarioOpcao} obj2 Segundo objeto a ser comparado
     * @returns {Boolean} Retorna verdadeiro se os dois objetos forem iguais
     */
    static compare(obj1, obj2) {
        //Se os dois possuírem o mesmo endereço de memória
        if (obj1 === obj2)
            return true;
        //Se um dos dois for nulo
        if (!obj1 || !obj2)
            return false;
        //Compara as propriedades
        let result = obj1.valido === obj2.valido
                  && obj1.erroOpcao === obj2.erroOpcao
                  && obj1.descricao === obj2.descricao
                  && obj1.imagem === obj2.imagem
                  && obj1.valor === obj2.valor;

        return result;
    }

}

export default ErroQuestionarioOpcao;